import React, { Component } from 'react';
import "../styles/parallaxCollage1.css";
import { Link } from "react-router-dom";

export default class ParallaxCollage1 extends Component {
  render() {
    return (
      <div id="parallax-collage-1" className="row">
    		<div id="parallax-collage-1-background" className="small-12 medium-7" style={{backgroundImage: "url(" + this.props.backgroundImage + ")"}}>
    			<img alt="" id="parallax-collage-1-image-1" src={this.props.image1} />
    			<img alt="" id="parallax-collage-1-image-2" src={this.props.image2} />
    		</div>
    		<div id="parallax-collage-1-content-container " className="small-12 medium-5">
    			<div id="parallax-collage-1-content">
    				<h1 id="parallax-collage-title">{this.props.title}</h1>
    				<div id="parallax-collage-description-container">
    					<p className="collage-text">{this.props.description}</p>
    					<Link className="cta" exact to={this.props.link}>{this.props.cta}</Link>
    				</div>
    			</div>
    		</div>
	    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/parallaxCollage1.js